 document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('.accordion .accordion-heading');

    function toggleAccordion() {
      const itemToggle = this.getAttribute('aria-expanded');

      for (i = 0; i < items.length; i++) {
        items[i].setAttribute('aria-expanded', 'false');
      }

      if (itemToggle == 'false') {
        this.setAttribute('aria-expanded', 'true');
      }
    }

    items.forEach((item) => item.addEventListener('click', toggleAccordion));
   
  });


window.addEventListener('scroll', function() {
    var product = document.getElementById('product-id');
    
    if (product) {
        var productOffset = product.getBoundingClientRect().top + window.scrollY;
        var windowHeight = window.innerHeight;
        var scrollTop = window.scrollY;

        // Check if the element is visible in the viewport
        if (scrollTop + windowHeight > productOffset && scrollTop < productOffset + product.offsetHeight) {
            var stickyProducts = document.querySelectorAll('.sticky-product');
            stickyProducts.forEach(function(product) {
                product.classList.remove('active');
            });
        } else {
            var stickyProducts = document.querySelectorAll('.sticky-product');
            stickyProducts.forEach(function(product) {
                product.classList.add('active');
            });
        }
    } else {
        var stickyProducts = document.querySelectorAll('.sticky-product');
        stickyProducts.forEach(function(product) {
            product.classList.add('active');
        });
    }
});
